





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";

@Component({
  components: {},
})
export default class AutoCompleteProsedur extends Vue {
  @Prop() dokterDefault: object;
  @Prop() unit_id: string;
  @Prop() length: number;
  @Prop() index: number;
  @Prop() autofocus: boolean;
  @Prop() disabled: boolean;
  @Prop() prosedur = {
    kode: null,
    nama: null,
    tgl: null,
    unit_id: null,
    dr_id: null,
  };
  listProsedur = [];
  searchString = null;
  _timerId;

  removeItem() {
    this.$emit("removeItem");
  }
  addProc() {
    this.$emit("addProc");
  }
  changeProsedur(val) {
    if (val) {
      console.log("val", val);
      this.prosedur.kode = val["value"];
      this.prosedur.nama = val["label"];
      this.prosedur.tgl = new Date().toISOString().substr(0, 10);
      this.prosedur.unit_id = this.unit_id;
      this.prosedur.dr_id = this.dokterDefault["id"];

      this.$emit("selectedItem", {
        prosedur: this.prosedur,
        index: this.index,
      });
    }
  }

  @Watch("searchString")
  searched() {
    this.listProsedur = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchProsedur(this.searchString);
    }, 500);
  }
  searchProsedur(termSearch) {
    http
      .getDataParam(`/referensi/prosedur-icd/search`, {
        params: { term: termSearch },
      })
      .then((res) => {
        this.listProsedur = res.data;
      })
      .finally();
  }
}
